module.exports = __webpack_public_path__ + "static/media/pdf.e806e59c.svg";